import React, { useState, useEffect, useRef } from 'react';

import Tag from '../components/Tag';
import Button from '../components/Button';

import Headerbar from './Headerbar'

function JuniorArm(props) {
  const bannerRef = useRef(null);
  const [height, setHeight] = useState(0);

  const Row = (props) => {
    return(<div className='border-t-[1px] border-blue p-[0.5rem] w-full h-fit keplersemi flex flex-row space-x-[0.5rem]'>
      {props.children}
    </div>)
  }

  useEffect(() => {
    const bannerHeight = () => {
      if (bannerRef.current && bannerRef.current.getBoundingClientRect().height !== height) {
        let h = bannerRef.current.getBoundingClientRect().height;
        setHeight(h)
      }
    }

    bannerHeight();
    window.addEventListener('resize', bannerHeight);
    setInterval(()=>{
      bannerHeight();
    }, 500)

    return () => {
      window.removeEventListener('resize', bannerHeight);
    }
  }, []);

    return (
    <div className='relative w-full flex flex-col justify-start items-center min-h-[840px] h-full text-blue pt-[4.5rem]'
      onMouseEnter={() => props.setHover({})}>
      <div className='flex my-auto w-full h-fit lg:max-h-[1000px] p-[1.5rem] md:p-[3rem] xl:px-[6rem] relative z-0 max-w-[2000px]'>
        <div className='min-h-fit h-full w-full flex flex-col md:flex-row items-start justify-start pb-[2rem] md:pb-0'>
          <div id='Banner' ref={bannerRef} className='w-full lg:w-1/2 xl:w-1/3 3xl:min-w-[500px] h-fit mb-[2rem] md:mb-0 md:mr-[1rem] fadein'>
            <div className='lg:max-w-[800px] driftinfast relative left-0 flex flex-col justify-start items-start h-fit min-h-full'>
              <a className='keplersemi text-blue w-fit inline md:hidden mb-[2rem]' href='/projects'>
              <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>


              <div className='w-full h-full flex flex-col justify-start space-y-[1rem]'>
                <div>
                  <img className='mb-[1rem] w-[100%] h-auto max-w-[450px]' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/title.png'
                  alt='6dof arm'/>
                  <div className='flex w-full h-fit py-[0.5rem] justify-start flex-wrap'>
                    <Tag text={'Ongoing'}/>
                    <Tag text={'CAD'}/>
                    <Tag text={'Mechatronics'}/>
                    <Tag text={'Simulation'}/>
                    <Tag text={'Prototyping'}/>
                  </div>
                </div>

                <div className='w-full flex justify-start items-start'>
                  <p className='min-w-[300px] text-start'>
                    When I made the jump from software engineering into robotics early 2025, I wanted to get a <mark>full-stack robotics experience</mark> by creating a 6 degree-of-freedom robot arm from scratch. I gave it a fitting name: "Junior."
                    <br/><br/>I started the project with zero background in <mark>CAD, electronics, or motion planning,</mark> but I built a solid foundation in all three through many hours of iteration and YouTube tutorials. I designed and 3D-printed my own <mark>cycloidal gearboxes and capstan drives,</mark> wrote the C++ firmware that drives the NEMA 17 stepper motors with smooth <mark>cubic-Bézier acceleration profiles,</mark> and built a PyBullet simulation to solve the arm's <mark>inverse kinematics</mark> and plan its motions to reach different positions.
                    <br/><br/>My coursework and research have since taught me a great deal about <mark>machining, mechanical design, and controlling dynamic systems</mark>. I'm excited to bring that experience back to Junior with more robust components, a smarter embedded system, and a lot more swag.
                  </p>
                </div>

                <div className='w-full text-blue keplersemi'>
                  <div className='flex w-full h-fit pt-0 justify-start items-start flex-col text-blue keplermed'>
                    <Row>
                      <div className='min-w-[8rem]'>DURATION</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>Jun 2023 ~ Sep 2023</p>
                      </div>
                    </Row>
                    <Row>
                      <div className='min-w-[8rem]'>SKILLS<br/>DEVELOPED</div>
                      <div className='flex flex-col justify-start items-start keplermed'>
                        <p>1) Basics of CAD design for 3D printing</p>
                        <p>2) Gearbox design, assembly</p>
                        <p>3) Embedded systems & motor control, motion profiling</p>
                        <p>4) Inverse kinematics, robotics simulation</p>
                      </div>
                    </Row>
                  </div>
                </div>

                <div className='w-full flex justify-start items-center keplersemi'>
                  <Button ReducedMotion = {props.ReducedMotion} link={'https://github.com/choi-choi-train/6dof-arm-project'} download={true}
                    setHover={props.setHover}>
                    <img className='h-[1rem] mr-[0.5rem] aspect-square object-contain' src={require('../images/github.png')} alt='github repository'/>
                    <div>PROJECT GITHUB</div>
                  </Button>
                </div>

                <a className='keplersemi text-blue w-fit hidden md:inline' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
                </a>
              </div>
            </div>
          </div>

          <div id='scroll' className='relative w-full lg:w-1/2 xl:w-2/3 3xl:w-full flex flex-row z-0 justify-start items-start pb-[2rem] md:pb-[1rem] md:pl-[1rem]' 
            style={{height: (window.innerWidth > 768) ? height : 'fit'}}>

            <div className='driftinleft hidden md:inline absolute -z-10 w-[100%] h-[100%] right-[1.5rem] top-[1rem] pl-[1.5rem] pb-[1rem]'>
              <img className='dropshadow object-cover w-full h-full' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/sand.png' 
              alt='textured background'/>
            </div>

            <div className='bg-white w-full h-fit md:h-full flex flex-col space-y-[0.5rem] justify-start items-start md:overflow-y-scroll'>
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  V1: Full Arm CAD Model
                </div>
              </div>
              <div className='w-full grid grid-cols-2 gap-2'>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv1_1.png'
                alt='CAD screenshot'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv1_2.png' 
                alt='CAD screenshot'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv1_3.png'
                alt='CAD screenshot'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv1_4.png'
                alt='CAD screenshot'/>
              </div>
              
              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  PyBullet Simulation and Motion Planning
                </div>
              </div>
              <div className='w-full flex flex-row gap-2'>
                <img className='w-1/2 aspect-square h-auto object-top object-contain overflow-hidden' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/simplified_model.png'
                alt='simplified model frames'/>
                <img className='w-1/2 aspect-square h-auto object-top object-cover overflow-hidden' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/sim_screenshot.png'
                alt='simulation screenshot'/>
              </div>
              <video className='w-full h-auto object-top' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/simulation.mp4'
              alt='pybullet simulation'
                controls='on' autoplay='true' loop='true'/>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  V2: Joint Drive Designs (Cycloidal, Capstan Drive)
                </div>
              </div>
              <div className='w-full grid grid-cols-2 gap-2'>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv2_cycloidalgearbox.png' 
                alt='cycloidal gearbox'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv2_capstandrive.png' 
                alt='capstan drive'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv2_capstandrive2.png' 
                alt='capstan drive'/>
                <img className='w-full aspect-square h-auto object-center object-contain' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/juniorv2_shoulderjoint.png' 
                alt='shoulder joint assembly'/>
              </div>

              <div className='border-y-[3px] border-blue py-[4px] w-full md:sticky top-0'>
                <div className='border-y-[1px] border-blue flex w-full px-[0.5rem] keplersemi py-[0.5rem] bg-white'>
                  Prototyped Gearbox Control & Testing
                </div>
              </div>
              <div className='w-full grid grid-cols-2 gap-2'>
                <video muted className='w-full h-auto object-top' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/cycloid_interior.mov' 
                alt='cycloidal drive interior'
                  controls='on' autoplay='true' loop='true'/>
                <video muted className='w-full h-auto object-top' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/cycloid_positioning.mov' 
                alt='cycloidal drive position homing'
                  controls='on' autoplay='true' loop='true'/>
                <video muted className='w-full h-auto object-top' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/capstanpositioning.mov' 
                alt='capstan drive position homing'
                  controls='on' autoplay='true' loop='true'/>
                <video muted className='w-full h-auto object-top' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/projects/juniorarm/capstanrom.mov' 
                alt='capstan drive ROM'
                  controls='on' autoplay='true' loop='true'/>
              </div>

              <a className='keplersemi text-blue w-fit lg:hidden my-[2rem]' href='/projects'>
                <Button {... props}>
                  <div className='flex flex-row space-x-[0.5rem] justify-start items-center'>
                    <img className='h-[1rem] aspect-square' src={require('../images/dropdown.png')} alt='arrow'/>
                    <div className='pt-[3px]'>{'Back to Projects'}</div>
                  </div>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Headerbar {... props}/>
    </div> );
}

export default JuniorArm;